<template>
  <div
    class="nova-contextmenu"
    @contextmenu.capture.prevent.stop="void 0"
    @mousedown.capture.stop.prevent="void 0"
    :style="{ left, top }"
  >
    <ul>
      <template v-for="(item, index) in menu">
        <li :key="`item-${index}`" v-if="handleShow(item)" @click.stop.prevent="handleClick(item)">
          {{ item.text }}
        </li>
      </template>
    </ul>
  </div>
</template>

<script>
import { isFunction } from '@/utils/is';
export default {
  props: {
    appendToBody: {
      type: Boolean,
      default: true
    },
    container: {
      type: [String, HTMLElement],
      default: () => ({})
    },
    x: {
      type: Number,
      default: 0
    },
    y: {
      type: Number,
      default: 0
    },
    menu: {
      type: Array,
      default: () => []
    },
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      windowWidth: document.documentElement.clientWidth,
      windowHeight: document.documentElement.clientHeight
    };
  },
  computed: {
    left() {
      if (this.x > this.windowWidth - 186) {
        return `${this.windowWidth - 186}px`;
      }

      return `${this.x}px`;
    },
    top() {
      const menuHeight = this.menu.length * 33 + 16;
      if (this.y + menuHeight > this.windowHeight) {
        return `${this.windowHeight - menuHeight}px`;
      }

      return `${this.y}px`;
    }
  },
  methods: {
    doDestroy() {
      this.$destroy();
    },
    handleClick(item) {
      if (isFunction(item.event)) {
        item.event(this.data);
      }

      this.doDestroy();
    },
    handleShow(item) {
      if (isFunction(item.show)) return item.show();

      return true;
    }
  },
  mounted() {
    if (this.appendToBody) {
      document.body.appendChild(this.$el);
    } else {
      this.container.appendChild(this.$el);
    }
    document.addEventListener('click', this.doDestroy, false);
    document.addEventListener('contextmenu', this.doDestroy, true);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.doDestroy, false);
    document.removeEventListener('contextmenu', this.doDestroy, true);
  },
  destroyed() {
    // if appendToBody is true, remove DOM node after destroy
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
  }
};
</script>

<style lang="scss">
.nova-contextmenu {
  --primary-color: #01cad8;

  position: fixed;
  left: 0;
  top: 0;
  z-index: 999;

  border-radius: 6px;
  padding: 6px 0;

  width: 184px;

  font-size: 14px;

  overflow: hidden;

  pointer-events: auto !important;

  border: 1px solid var(--primary-color);
  box-shadow: 0px 0px 4px 0.8px #489cd6;
  background: #1c3755;
  color: var(--primary-color);

  ul {
    li {
      // --border-gap: 0%;

      list-style: none;
      padding: 7px 15px;

      cursor: pointer;

      transition: background 0.3s ease;

      // &:not(:last-child) {
      //   border-bottom: 1px solid;
      //   border-image: linear-gradient(
      //       to right,
      //       transparent var(--border-gap),
      //       var(--primary-color) var(--border-gap),
      //       var(--primary-color) calc(100% - var(--border-gap)),
      //       transparent calc(100% - var(--border-gap))
      //     )
      //     1;
      // }

      &:hover {
        background: #02757e;
      }
    }
  }
}
</style>
